<template>
  <div>
    <section>
      <v-form> </v-form>
    </section>
  </div>
</template>

<script>
export default {
  name: "member-management-personnel-records-edit-deadlines",
  components: {},
  data() {
    return {};
  },
};
</script>

<style></style>
